html, body, #root {
    height: 100%;
    width: 100%;
    overflow: hidden;
    /* This is the magic bullet for iOS Safari to stop accidental URL bar collapsing */
    position: fixed;
}

body{
    overflow:hidden;
    background-color: #f9fafa;
}
#root{
    display:flex;
}

input {
    outline:none;
    -webkit-outline: none;
    -moz-outline: none;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-smoothing: antialiased;

}

button {
    outline:none;
    -webkit-outline: none;
    -moz-outline: none;
}

textarea {
    flex-grow: 1;
    height: 30px;
    overflow: hidden;
    outline: none;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-smoothing: antialiased;
}

div{
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-smoothing: antialiased;
}

.no-select
{
    user-select: none;
    -o-user-select:none;
    -moz-user-select: none;
    -khtml-user-select: none;
    -webkit-user-select: none;
}
